enum KubernetesAppName {
  Homepage = 'homepage',
  MerchUI = 'merchui',
  SRP = 'srp'
}

export default KubernetesAppName;
